import { useState, useEffect, useContext } from "react";
import {
  Form,
  Typography,
} from "antd";
import "./auditforms.css";
import { Link, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import CustomLoader from "../../common/customLoader";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import TableContent from "../../../components/atoms/TableContent";
import AddAuditForm from "./addAuditForms";
import media from "../../../media";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchAFProcessesThunk, fetchAuditFormsThunk } from "../../../store/thunks/auditFormsThunk";

const AuditForms = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname.replace("/", "");
  const [tableForm] = Form.useForm();

  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.qmsAuditForms
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;

  const [showLoader, setShowLoader] = useState(true);

  const slsRole = secureLocalStorage.getItem("role");
  
  const [statuses, setStatuses] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" },
  ]);
  const [processes, setProcesses] = useState([])
  const [modalOpen, setModalOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  
  const [formTitle, setFormTitle] = useState("");
  const [formProps, setFormProps] = useState({});  
  const [editingKey, setEditingKey] = useState("");

  const openAddModal = () => {
    setEditRecord(null);
    setModalOpen(true);

    setFormTitle("Add Audit Form");
    setFormProps({      
      processes: processes,
      onSuccess: () => {
        dispatch(
          fetchAuditFormsThunk({
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue: secureLocalStorage.getItem("hasSearchedValue")
              ? "yes"
              : "",
            searchKeyword:
              secureLocalStorage.getItem("searchKeyword") || "",
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
          })
        );         
        setModalOpen(false);
      },
    });
  };

  const openEditModal = (record) => {
    
    setEditRecord({
      ...record,
      id: record.key,
    });
    
    setFormTitle("Edit Audit Form");
    secureLocalStorage.setItem("fromComponent", "auditForms");
    
    setFormProps({      
      editData: record, 
      processes: processes,         
      editRouteState: {
        route: location.pathname,
        auditFormHasWeightage: record.hasWeightage,
      },
      onSuccess: () => {
        dispatch(
          fetchAuditFormsThunk({
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue: secureLocalStorage.getItem("hasSearchedValue")
              ? "yes"
              : "",
            searchKeyword:
              secureLocalStorage.getItem("searchKeyword") || "",
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
          })
        ); 
        setModalOpen(false);        
      },
    });
    setModalOpen(true);
  };
  
  const additionalColumns = [];
  const columns = [
    {
      title: () => {
        return <div className="tableTitle"><img src={media.departmentName.svg} alt="icon" />ID</div>;
      },
      dataIndex: "id",
      render: (text) => <span className="rowstyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"><img src={media.departmentIcon.svg} alt="icon" />Form Name</div>;
      },
      dataIndex: "form_name",
      render: (text, row) => (
        <Link
          to={"/auditForms/" + row.key}
          state={{
            route: location.pathname,
            auditFormHasWeightage: row.hasWeightage,
          }}
          style={{ color: "black" }}
          onClick={() => {
            secureLocalStorage.setItem("fromComponent", "auditForms");
          }}
        >
          <span className="rowstyle no-wrap bfont">
            {text}
          </span>
        </Link>
      ),
    },
    {
      title: () => {
        return <div className="tableTitle"><img src={media.totalAudits.svg} alt="icon" />Total Audits</div>;
      },
      dataIndex: "total_audits",

      render: (text) => <span className="rowstyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"><img src={media.activeAudits.svg} alt="icon" />Active Audits</div>;
      },
      dataIndex: "active_audits",

      render: (text) => <span className="rowstyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return <div className="tableTitle"><img src={media.departmentStatus.svg} alt="icon" />Status</div>;
      },
      dataIndex: "status",

      editable: true,
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (text, row) => (
        <span
          className={`cusStatus ${
            text?.toLowerCase() === "active" ? "cusActive" : "cusInActive"
          }`}
        >
          {text}
        </span>
      ),
    },
    {
      title: () => {
        return <div className="tableTitle"><img src={media.departmentDate.svg} alt="icon" />Created At</div>;
      },
      dataIndex: "createdAt",

      render: (text) => <span className="rowstyle ">{text}</span>,
    },
  ];
  (slsRole === process.env.REACT_APP_AROLE ||
    slsRole === process.env.REACT_APP_QC) &&
    additionalColumns.push(
      {
        title: () => {
          return <div className="tableTitle"><img src={media.departmentDate.svg} alt="icon" />Updated At</div>;
        },
        dataIndex: "updatedAt",
      },
      {
        title: () => {
          return <div className="tableTitle"><img src={media.departmentAction.svg} alt="icon" />Action</div>;
        },
        dataIndex: "action",

        render: (_, record) => {
          return (
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => openEditModal(record)}
              className="tableBtn bfont"
            >
               <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
            </Typography.Link>
          );
        },
      }
    );
  columns.push(...additionalColumns);
  const mergedColumns =
    columns &&
    columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
          statuses: statuses,
        }),
      };
    });

  /*begin::getAuditFormList will fetch list of audits*/

  /*begin::getProcesses will fetch the list of Processes*/
    const getProcesses = async () => {    
      const payload = { role: slsRole };
  
      await dispatch(fetchAFProcessesThunk(payload))
        .unwrap()
        .then((response) => {
          const temp = [];
          response?.map((process, index) => {
            temp.push({ label: process?.name, value: process?._id });
          });
  
          setProcesses(temp);
        })
        .catch((error) => {});
    };
    /*end::getProcesses will fetch the list of Processes*/
  

  // Fetch departments
  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        const res = await dispatch(
          fetchAuditFormsThunk({
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue,
            searchKeyword,
            route: currentPath,
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
          })
        ).unwrap();
      } catch (err) {
        console.error("Error fetching auditforms:", err);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
    getProcesses();
  }, [currentPath, pagination.current, pagination.pageSize, dispatch]);  
  
  /*end::getAuditFormList will fetch list of audits*/

  const isEditing = (record) => record.key === editingKey;

  return (
    <div className="all-content">
      <CustomLoader showLoader={showLoader} />

      <TopContainerHeader
        sectionTitle="Audit Forms"
        sectionDescription={
          showLoader
            ? "Loading..."
            : `${count || 0} Found`
        }
        hasSectionButton={true}
        sectionButtons={[
          {
            isVisible: true,
            itemType: "add",
            itemName: "Add",
            onClick: openAddModal,
          },
        ]}
        hasFilter={false}
        buttonTitle="Add New"
        FormComponent={AddAuditForm}
        formTitle={formTitle}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        formProps={formProps}
      />
      <div className="all-table-holder">
        <Form form={tableForm} component={false}>
          <TableContent
            className=""
            rowSelection={""}
            rowClassName="editable-row"
            bordered={false}
            columns={mergedColumns}
            dataSource={list}
            pagination={tablePagination}
          />
        </Form>
      </div>
    </div>
  );
};
export default AuditForms;
